// @ts-nocheck
import onePageCheckoutProductListOverlayReducer, {
    OnePageCheckoutProductListOverlayActions,
} from "@store/Framework/Store/Starter/Components/OnePageCheckoutProductListOverlay/OnePageCheckoutProductListOverlayReducer";
import { combineReducers } from "redux";
import accordionReducer from "@store/Framework/Store/Starter/Components/Accordion/AccordionReducer";
import formReducer from "@store/Framework/Store/Starter/Components/Form/FormReducer";
import styleguideReducer from "@store/Framework/Store/Starter/Components/Styleguide/StyleguideReducer";

const componentsReducer = combineReducers({
    accordion: accordionReducer,
    form: formReducer,
    onePageCheckoutProductListOverlay: onePageCheckoutProductListOverlayReducer,
    styleguide: styleguideReducer,
});

export type ComponentsActions = OnePageCheckoutProductListOverlayActions;

export default componentsReducer;
